var $7940365cce7a5f46$exports = {};
const $7940365cce7a5f46$var$cover = document.querySelector('.cover');
const $7940365cce7a5f46$var$vinyl = document.querySelector('.vinyl');
const $7940365cce7a5f46$var$playerA = document.querySelector('#sidea');
const $7940365cce7a5f46$var$timeStamps = document.querySelectorAll('.time-travel');
const $7940365cce7a5f46$var$startPlayback = (player)=>{
    $7940365cce7a5f46$var$vinyl.classList.remove('recover');
    $7940365cce7a5f46$var$vinyl.classList.add('uncover');
};
const $7940365cce7a5f46$var$stopPlayback = ()=>{
    $7940365cce7a5f46$var$vinyl.classList.add('recover');
    $7940365cce7a5f46$var$vinyl.classList.remove('uncover');
};
$7940365cce7a5f46$var$playerA.addEventListener('play', ()=>{
    $7940365cce7a5f46$var$startPlayback('playerA');
});
$7940365cce7a5f46$var$playerA.addEventListener('pause', ()=>{
    $7940365cce7a5f46$var$stopPlayback();
});
$7940365cce7a5f46$var$vinyl.addEventListener('animationend', (event)=>{
    switch(event.animationName){
        case 'uncover':
            $7940365cce7a5f46$var$vinyl.classList.remove('uncover');
            $7940365cce7a5f46$var$vinyl.classList.add('spin');
            break;
    }
});
$7940365cce7a5f46$var$timeStamps.forEach((timeStamp)=>{
    timeStamp.addEventListener('click', ()=>{
        const time = parseInt(timeStamp.dataset.timestamp);
        $7940365cce7a5f46$var$playerA.currentTime = time;
        if ($7940365cce7a5f46$var$playerA.paused) $7940365cce7a5f46$var$playerA.play();
    });
});
function $7940365cce7a5f46$var$randomFlicker() {
    const els = document.querySelectorAll('.flicker-wrapper .layer');
    els.forEach((el)=>{
        const flick = Math.random();
        if (flick < 0.1) {
            el.style.opacity = '0.3';
            el.style.textShadow = 'none';
        } else if (flick < 0.2) {
            el.style.opacity = '0.5';
            el.style.textShadow = '0 0 2px lightblue';
        } else {
            el.style.opacity = '0.7';
            el.style.textShadow = '0 0 10px lightblue';
        }
    });
    setTimeout($7940365cce7a5f46$var$randomFlicker, Math.random() * 400);
}
function $7940365cce7a5f46$var$headlineFlicker() {
    const els = document.querySelectorAll('h2 .layer');
    els.forEach((el)=>{
        const flick = Math.random();
        if (flick < 0.1) {
            el.style.opacity = '0.1';
            el.style.textShadow = 'none';
        } else if (flick < 0.2) el.style.opacity = '0.25';
        else el.style.opacity = '1';
    });
    setTimeout($7940365cce7a5f46$var$headlineFlicker, Math.random() * 1800);
}
$7940365cce7a5f46$var$randomFlicker();
$7940365cce7a5f46$var$headlineFlicker();


//# sourceMappingURL=index.10d5593c.js.map
